import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NAV_LEVEL_LIST } from '@constants/navbar';
import { ROUTES_ADMIN } from '@constants/routes';
import { MenuNavbarUrl, NavBarListItem } from '@models/entities/navbar';
import { FeatureFlagsService } from '@providers/feature-flags/feature-flags.service';
import { ModalService } from '@providers/modal/modal.service';
import { TranslationService } from '@providers/translation-new/translation.service';
import { UserManagerService } from '@providers/user-manager/user-manager.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.html',
    styleUrls: ['./navbar.scss'],
    standalone: false
})
export class NavbarComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Output() toggleMenuEvent = new EventEmitter<void>();
  currentNavAccessLevel: NavBarListItem;
  language;

  constructor(
    private featureFlagsService: FeatureFlagsService,
    private modal: ModalService,
    private translation: TranslationService,
    private userManager: UserManagerService
  ) {}

  ngOnInit() {
    this.language = this.translation.getLangMessagesByKeys([
      'labels',
      'global',
      'actions',
    ]);
    this.currentNavAccessLevel =
      NAV_LEVEL_LIST[this.userManager.level || 'dev'];
    this.verifyFeatureFlag();
  }

  async verifyFeatureFlag(): Promise<void> {
    const indexFind = this.currentNavAccessLevel.topNav.findIndex(
      module => module.route === ROUTES_ADMIN.ENTERPRISES_CONNECT
    );
    try {
      const isPresentConnect: string =
        await this.featureFlagsService.evalFeature('connect');
      if (!isPresentConnect && indexFind !== -1) {
        this.currentNavAccessLevel.topNav.splice(indexFind, 1);
      }
    } catch (e) {
      if (indexFind !== -1) {
        this.currentNavAccessLevel.topNav.splice(indexFind, 1);
      }
    }
  }

  toggleMenu() {
    if (this.isMobile) {
      this.toggleMenuEvent.emit();
    }
  }

  inProcess(item: MenuNavbarUrl) {
    if (!item.enable) {
      const {
        labels: { inProcess },
        global: { inProcessD },
        actions: { understood },
      } = this.language;
      const data = {
        title: inProcess,
        message: inProcessD,
        btnSave: understood,
      };
      this.modal.showAlert(data);
    }
  }
}
